import { withFeatureProps } from '../features';
import BaseHeader from './Header';

const Header = withFeatureProps(BaseHeader);

export default Header;
